// src/dataCache.js
const dataCache = {};

export default dataCache;
